import React from "react";
import LandlordForm from "./LandlordForm";

export default function AddLandlord(){
    return <LandlordForm type="Add" />
}